const DAWN_CART_TAGS = ['cart-drawer', 'cart-items', 'cart-drawer-items', 'cart-notification'];
const DAWN_PUBSUB_REFRESHED_SECTIONS = new Set(['cart-drawer:cart-drawer','cart-drawer-items:CartDrawer','cart-items:main-cart-items']);
function collectCartSections(){const sections=new Map();for(const el of document.querySelectorAll(DAWN_CART_TAGS.join(','))){let entries;try{entries=el.getSectionsToRender?.();}catch{continue;}const tag=el.tagName.toLowerCase();for(const entry of entries??[]){if(DAWN_PUBSUB_REFRESHED_SECTIONS.has(`${tag}:${entry.id}`))continue;const sectionId=entry.section??entry.id;if(!sectionId||sections.has(sectionId))continue;const root=entry.section?document.getElementById(entry.id):document;if(!root)continue;const mount=entry.selector?(root.querySelector(entry.selector)??(entry.section?root:null)):document.getElementById(entry.id);if(!mount)continue;sections.set(sectionId,{mount,extractSelector:entry.selector||'.shopify-section'});}}return sections;}
async function refreshDawnCartUI(){const sections=collectCartSections();const sectionsQuery=sections.size?`?sections=${[...sections.keys()].join(',')}`:'';const cartUrl=(typeof routes!=='undefined'&&routes?.cart_url)||'/cart';const cartData=await fetch(`${cartUrl}.js${sectionsQuery}`,{headers:{Accept:'application/json'}}).then(r=>r.ok?r.json():null).catch(()=>null);if(cartData?.sections){for(const[id,{mount,extractSelector}]of sections){const html=cartData.sections[id];if(!html)continue;const source=new DOMParser().parseFromString(html,'text/html').querySelector(extractSelector);if(source)mount.replaceChildren(...source.childNodes);}}publish(PUB_SUB_EVENTS.cartUpdate,{source:'external-refresh',cartData:cartData??undefined});}
function initStandardActions(){const actions=window.Shopify?.actions;if(!actions)return;actions.openCart.configure({async handler(defaultHandler){const drawer=document.querySelector('cart-drawer');if(drawer&&typeof drawer.open==='function'){drawer.open();return;}return defaultHandler();}});actions.updateCart.configure({eventTarget:()=>document,async handler(defaultHandler){const result=await defaultHandler();try{await refreshDawnCartUI();}catch(error){console.error('[Dawn] Standard Actions cart refresh failed; reloading.',error);window.location.reload();}return result;}});}
if(window.Shopify?.actions)initStandardActions();else document.addEventListener('DOMContentLoaded',initStandardActions,{once:true});

(function initYalordeBadgeOverlay(){return;/* YL Oct 2026: retired - badges now rendered by theme Liquid (.ylu-badge) */
  const STYLE_ID='yalorde-badge-overlay-style';
  let style=document.getElementById(STYLE_ID);
  if(!style){style=document.createElement('style');style.id=STYLE_ID;document.head.appendChild(style);}
  style.textContent=`
    .card-wrapper .card__inner,
    .product-card-wrapper .card__inner { position: relative !important; }

    .yl-badge-stack {
      position: absolute !important;
      top: 10px !important;
      left: 10px !important;
      right: auto !important;
      bottom: auto !important;
      z-index: 12 !important;
      display: flex !important;
      flex-direction: column !important;
      align-items: flex-start !important;
      gap: 6px !important;
      width: auto !important;
      max-width: calc(100% - 20px) !important;
      margin: 0 !important;
      padding: 0 !important;
      pointer-events: none !important;
    }

    .yl-badge-stack .badge,
    .yl-badge-stack .yl-fav-badge {
      position: static !important;
      top: auto !important;
      left: auto !important;
      right: auto !important;
      bottom: auto !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      width: auto !important;
      min-width: 0 !important;
      max-width: max-content !important;
      margin: 0 !important;
      line-height: 1 !important;
      white-space: nowrap !important;
      transform: none !important;
      box-shadow: none !important;
    }

    .yl-badge-stack .yl-sale-badge {
      background: #c62828 !important;
      color: #ffffff !important;
      border: 0 !important;
      border-radius: 5px !important;
      padding: 6px 10px !important;
      font-family: var(--font-body-family) !important;
      font-size: 10px !important;
      font-weight: 700 !important;
      letter-spacing: .09em !important;
      text-transform: uppercase !important;
    }

    .yl-badge-stack .yl-best-badge {
      background: #0b0b0b !important;
      color: #d7b26d !important;
      border: 0 !important;
      border-radius: 5px !important;
      padding: 6px 10px !important;
      font-family: var(--font-body-family) !important;
      font-size: 10px !important;
      font-weight: 700 !important;
      letter-spacing: .09em !important;
      text-transform: uppercase !important;
    }

    .yl-badge-stack .yl-soldout-badge {
      background: #ffffff !important;
      color: #000000 !important;
      border: 1px solid rgba(0,0,0,.18) !important;
      border-radius: 5px !important;
      padding: 6px 10px !important;
      font-family: var(--font-body-family) !important;
      font-size: 10px !important;
      font-weight: 600 !important;
      letter-spacing: .06em !important;
      text-transform: uppercase !important;
    }

    @media screen and (max-width: 749px) {
      .yl-badge-stack {
        top: 8px !important;
        left: 8px !important;
        gap: 5px !important;
        max-width: calc(100% - 16px) !important;
      }
      .yl-badge-stack .yl-sale-badge,
      .yl-badge-stack .yl-best-badge,
      .yl-badge-stack .yl-soldout-badge {
        padding: 5px 8px !important;
        font-size: 9px !important;
      }
    }
  `;

  function normalize(text){return(text||'').replace(/\s+/g,' ').trim().toLowerCase();}

  function ensureStack(card){
    const inner=card.querySelector('.card__inner');
    if(!inner)return null;
    let stack=inner.querySelector(':scope > .yl-badge-stack');
    if(!stack){stack=document.createElement('div');stack.className='yl-badge-stack';inner.appendChild(stack);}
    return stack;
  }

  function moveBadge(stack,badge,type){
    if(!stack||!badge)return;
    const selector=type==='sale'?'.yl-sale-badge':type==='best'?'.yl-best-badge':'.yl-soldout-badge';
    if(stack.querySelector(selector)){badge.remove();return;}
    badge.classList.remove('yl-fav-badge');
    if(type==='sale'){
      badge.textContent='SALE';
      badge.classList.add('yl-sale-badge');
    }else if(type==='best'){
      badge.textContent='BEST SELLER';
      badge.classList.add('yl-best-badge');
    }else{
      badge.classList.add('yl-soldout-badge');
    }
    stack.appendChild(badge);
  }

  function processCard(card){
    const stack=ensureStack(card);
    if(!stack)return;
    const candidates=[...card.querySelectorAll('.card__badge .badge, .card__media .yl-fav-badge')];
    for(const badge of candidates){
      if(stack.contains(badge))continue;
      const text=normalize(badge.textContent);
      if(text==='sale'||text==='on sale')moveBadge(stack,badge,'sale');
      else if(text==='best seller'||text==='customer favorite'||text==='customer favourite')moveBadge(stack,badge,'best');
      else if(text==='sold out')moveBadge(stack,badge,'soldout');
    }
    if(!stack.children.length)stack.remove();
  }

  function apply(root=document){
    if(root.matches?.('.card-wrapper,.product-card-wrapper'))processCard(root);
    root.querySelectorAll?.('.card-wrapper,.product-card-wrapper').forEach(processCard);
  }

  function start(){
    apply();
    const observer=new MutationObserver(mutations=>{
      for(const mutation of mutations){
        for(const node of mutation.addedNodes){if(node.nodeType===1)apply(node);}
      }
    });
    observer.observe(document.body,{childList:true,subtree:true});
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
